import { Component } from '@mycolorway/tao';
import { MDCMenu } from '@material/menu';
import { Corner } from '@material/menu-surface';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

export default Component('tr-nested-menu', {
  mixins: [eventListenerMixin],

  properties: {
    anchorCorner: {
      type: String,
      default: 'bottom_left',
    },

    anchorSelector: String,

    appendMenuToBody: {
      type: Boolean,
      default: false,
    },

    quickOpen: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    if (this.anchorSelector) {
      this.anchor = this.querySelector(this.anchorSelector);
    } else {
      this.anchor = this.firstElementChild;
    }

    if (!this.mdcMenu) {
      this.menu = this.querySelector('.mdc-menu-surface');
      this.mdcMenu = new MDCMenu(this.menu);
    }
    this.mdcMenu.quickOpen = this.quickOpen;
    // eslint-disable-next-line no-underscore-dangle
    this.mdcMenu.menuSurface_.getDefaultFoundation().adapter_.setTransformOrigin('right top');
    this.mdcMenu.setAnchorCorner(Corner[this.anchorCorner.toUpperCase()]);

    this.addEventListeners();
  },

  disconnected() {
    this.stopListening();

    if (this.mdcMenu) {
      this.mdcMenu.quickOpen = true;
      this.mdcMenu.destroy();
    }
  },

  addEventListeners() {
    if ($(this.anchor).data('mode') === 'hover') {
      this.listenTo(this.anchor, 'mouseover', this.handleAnchorMouseover.bind(this));
      this.listenTo(this.anchor, 'mouseleave', this.handleAnchorMouseleave.bind(this));
    } else {
      this.listenTo(this.anchor, 'click', this.handleAnchorClick.bind(this));
    }

    this.listenTo(this.mdcMenu, {
      'MDCMenu:selected': this.handleMenuItemSelected.bind(this),
    });
    // eslint-disable-next-line no-underscore-dangle
    this.listenTo(this.mdcMenu.menuSurface_, {
      'MDCMenuSurface:closed': this.handleMenuClosed.bind(this),
    });

    // eslint-disable-next-line no-underscore-dangle
    this.listenTo(this.mdcMenu.menuSurface_, {
      'MDCMenuSurface:opened': this.handleMenuOpened.bind(this),
    });

    this.listenTo(document, 'mousedown', this.handleDocumentMousedown.bind(this));
  },

  handleAnchorMouseover() {
    if (this.mdcMenu.open === true) return;

    if (this.appendMenuToBody) this.mdcMenu.hoistMenuToBody();
    this.mdcMenu.open = true;
  },

  handleAnchorMouseleave(event) {
    if (this.mdcMenu.open === false) return;

    if (!this.menu.contains(event.relatedTarget) && this.mdcMenu.open) {
      this.mdcMenu.open = false;
    }
  },

  handleAnchorClick() {
    if (this.appendMenuToBody) this.mdcMenu.hoistMenuToBody();
    this.mdcMenu.open = !this.mdcMenu.open;
  },

  handleMenuItemSelected(event) {
    this.namespacedTrigger('selected', {
      detail: event.detail,
      bubbles: true,
    });
  },

  handleMenuClosed() {
    if (this.appendMenuToBody && this.menu) {
      this.insertAdjacentElement('beforeend', this.menu);
    }
    this.namespacedTrigger('closed', { bubbles: true });
  },

  handleMenuOpened() {
    this.namespacedTrigger('opened', { bubbles: true });
  },

  handleDocumentMousedown(event) {
    if (this.contains(event.target)) return;

    if (!this.menu.contains(event.target) && this.mdcMenu.open) {
      this.mdcMenu.open = false;
    }
    // click on nested menu
    if (this.menu.contains(event.target) && this.menu.className.indexOf('mdc-menu-nested') > -1) {
      this.mdcMenu.open = false;
    }
  },
});
